import { motion } from "framer-motion";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";
import { HIW_STEPS } from "../lib/howitworks";

const StageSequence = () => (
    <section
        data-testid="hiw-steps"
        className="relative bg-ink py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    THE JOURNEY
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    STEP 01 — 05
                </p>
            </motion.div>

            <motion.ol
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-16 space-y-20 lg:space-y-28"
            >
                {HIW_STEPS.map((step, i) => (
                    <motion.li
                        key={step.n}
                        variants={fadeUp}
                        data-testid={`hiw-step-${step.n}`}
                        className="relative grid items-center gap-10 lg:grid-cols-12"
                    >
                        <div
                            className={`lg:col-span-5 ${
                                i % 2 === 1 ? "lg:order-2" : ""
                            }`}
                        >
                            <figure className="group relative border border-white/12">
                                <div className="overflow-hidden">
                                    <img
                                        src={step.image}
                                        alt={step.alt}
                                        loading="lazy"
                                        className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                                    />
                                </div>
                                <figcaption className="flex items-center justify-between border-t border-white/10 px-4 py-3 font-mono text-[13px] tracking-[0.2em] text-cad">
                                    <span>{step.note}</span>
                                    <span>STEP {step.n}</span>
                                </figcaption>
                            </figure>
                        </div>

                        <div
                            className={`lg:col-span-7 ${
                                i % 2 === 1 ? "lg:order-1 lg:pr-10" : "lg:pl-10"
                            }`}
                        >
                            <span className="font-display text-6xl font-bold leading-none text-white/10 md:text-7xl">
                                {step.n}
                            </span>
                            <h3 className="mt-4 font-display text-3xl font-semibold leading-tight text-white md:text-4xl">
                                {step.title}
                            </h3>
                            <p className="mt-5 max-w-xl text-[16px] leading-relaxed text-mist">
                                {step.copy}
                            </p>
                        </div>
                    </motion.li>
                ))}
            </motion.ol>
        </div>
    </section>
);

export default StageSequence;
